<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9995 14.0002C16.4048 14.0002 19.9997 17.5951 19.9997 22.0004H21.9998C21.9998 17.9029 19.4864 14.2301 15.7038 12.7133C17.1469 11.574 17.9999 9.84573 17.9999 8.00038C17.9999 4.69631 15.3041 2 11.9995 2C8.696 2 5.99968 4.69688 5.99968 8.00038C5.99968 9.84686 6.84867 11.574 8.2932 12.7138C4.51292 14.2312 2 17.9049 2 22.0004H4.00013C4.00013 17.5959 7.59474 14.0002 11.9995 14.0002ZM15.9997 8.00038C15.9997 10.2054 14.2043 12.0001 11.9992 12.0001C9.79783 12.0001 7.99982 10.2018 7.99982 8.00038C7.99982 5.79616 9.79556 4.00012 11.9995 4.00012C14.2046 4.00012 15.9997 5.79559 15.9997 8.00038Z"
    />
  </svg>
</template>
